import React, { useState } from "react"
import {
  Checkbox,
  Radio,
  CircularProgress,
  FormHelperText,
  ListSubheader,
} from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ListItemText from "@material-ui/core/ListItemText"
import { SearchIcon } from "@iconsGallery"
import { Button, OutlinedInput, FormControl } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
// import * as QA_Automation from "@qaAutomation"

const useStyle = makeStyles({
  disableTextHover: {
    "& .MuiListItem-button:hover": {
      background: "transparent !important",
    },
  },
  formControl: {
    "& .MuiFormLabel-root.Mui-focused": {
      color: "var(--primaryColor)",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "var(--primaryColor)",
      },
    },
    "& .MuiList-root li:first-child": {
      padding: "8px 10px",
    },
  },
  menuCheckbox: {
    "& .MuiCheckbox-colorSecondary.Mui-disabled": {
      color: "gray !important",
    },
  },
  textInput: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
})

function SelectionLimitDropdown(props) {
  const {
    label = "",
    data: dropdownData = [],
    filteredItems = [],
    selectionItems=[],
    handleDropdownChange = () => "",
    handleSearchTerm = () => {},
    totalDocs = "",
    handleShowMore = () => {},
    searchTerm = "",
    fullWidth = false,
    isLookup = true,
    placeholder = "",
    valueIdentifier = "name",
    error,
    helperText,
    isShowFooter = true,
    isShowSearch = true,
    selectionLimit = 0,
    disableMenuName = "",
    isPlainObj = false,
    showDropdownItems = 2,
    checkbox = true,
    subKey = "",
    keyPath = "name",
  } = props || {}

  const isSingleSelect = selectionLimit === 1
  const classes = useStyle()
  const { t } = useTranslation()

  const [loading, setLoading] = React.useState(false)
  const [open, setOpen] = useState(false)
  const searchInputRef = React.useRef(null)  

  const [selectedItems, setSelectedItems] = React.useState(() => {
    if (isSingleSelect) {
      if (isPlainObj) return filteredItems?.[valueIdentifier] || ""
      return filteredItems || ""
    }

    if (isPlainObj) {
      return (filteredItems || []).map((item) => item[valueIdentifier])
    }

    return filteredItems || []
  })

  const [searchText, setSearchText] = React.useState(searchTerm)

  let ref = React.useRef()

React.useEffect(() => {
  if (!open) {
    setSearchText(searchTerm || "")
  }
}, [searchTerm, open])

  React.useEffect(() => {
    if (isSingleSelect) {
      setSelectedItems(
        isPlainObj
          ? filteredItems?.[valueIdentifier] || ""
          : filteredItems || ""
      )
    } else {
      setSelectedItems(
        isPlainObj
          ? (filteredItems || []).map((item) => item[valueIdentifier])
          : filteredItems || []
      )
    }
  }, [filteredItems, isSingleSelect, isPlainObj, valueIdentifier])

  React.useEffect(() => {
    // QA_Automation?.doAddOnTestIdCommonAutoCompleteDropdown(ref, props)
  }, [selectedItems, searchTerm, filteredItems])

  const ITEM_HEIGHT = 70
  const ITEM_PADDING_TOP = 5

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: () => null,
    anchorOrigin: { vertical: "bottom" },
  }

    const getSelectedObjects = (selectedValues) => {
    const currentSelection = Array?.isArray(selectionItems) ? selectionItems : [];

    const selectedMap = new Map(currentSelection?.map((item) => [item[valueIdentifier], item]));

    (dropdownData || []).forEach((item) => {
        if (selectedValues.includes(item[valueIdentifier])) {
        selectedMap.set(item[valueIdentifier], item);
        }
    });

    return selectedValues.map((val) => selectedMap.get(val))
        .filter(Boolean);
    };

  const getSingleSelectedObject = (selectedValue) => {
    return (
      dropdownData?.find((item) => item[valueIdentifier] === selectedValue) || ""
    )
  }

  const handleChange = (event) => {
    const value = event.target.value

    // ⭐ SINGLE SELECT MODE
    if (isSingleSelect) {
      setSelectedItems(value)

      if (isPlainObj) {
        const selectedObj = getSingleSelectedObject(value)
        handleDropdownChange(selectedObj, label, "isPlainObj")
      } else {
        handleDropdownChange(value, label)
      }

      setOpen(false)
      return
    }

    // ⭐ MULTI SELECT MODE
    let updatedValue = Array.isArray(value) ? value : []

    // safety guard only
    if (selectionLimit > 0 && updatedValue.length > selectionLimit) {
      updatedValue = updatedValue.slice(0, selectionLimit)
    }

    setSelectedItems(updatedValue)

    if (isPlainObj) {
      const selectedObjs = getSelectedObjects(updatedValue)
      handleDropdownChange(selectedObjs, label, "isPlainObj")
    } else {
      handleDropdownChange(updatedValue, label)
    }
  }

    const handleSearch = (val) => {
    setSearchText(val)
    }

    React.useEffect(() => {
    if (!open) return

    const timer = setTimeout(() => {
        handleSearchTerm(searchText, label)
    }, 300)

    return () => clearTimeout(timer)
    }, [searchText, label, open])

    React.useEffect(() => {
    if (open && searchInputRef.current) {
        setTimeout(() => {
        searchInputRef.current.focus()
        }, 0)
    }
    }, [open])

  return (
    <FormControl className={classes.formControl} fullWidth={fullWidth}>
      <Select
        multiple={!isSingleSelect}
        value={selectedItems}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(event) => {
          handleChange(event)
        }}
        defaultValue="none"
        placeholder={t(placeholder)}
        displayEmpty
        input={
          <OutlinedInput
            margin="dense"
            style={{ width: "30vh", height: "36px" }}
          />
        }
        renderValue={(selected) => {
          // MULTI SELECT - plain object (selected = primitive values internally)
          if (isPlainObj) {
            if (selectionItems?.length > 0) {
              const remaining = selectionItems.length - showDropdownItems

              return (
                <b>
                  {selectionItems.slice(0, showDropdownItems).map((i) => i[keyPath]).join(", ")}
                  {selectionItems.length > showDropdownItems &&
                    ` ${t("AND")} ${remaining} ${t("MORE")}`}
                </b>
              )
            }
            return <b>{t(label)}</b>
          }
        }}
        style={{
          backgroundColor: "transparent",
          height: "38px",
          width: fullWidth ? "100%" : isLookup ? "20vh" : "255px",
        }}
        id="id-detailedTransactionReport-common"
        labelId="id-detailedTransactionReport-common"
        MenuProps={{
          ...MenuProps,
          classes: { paper: "cls-detailedTransactionReport-common-type" },
          MenuListProps: {
            style: {
                paddingTop: 0,
                paddingBottom: 0, // optional
            },
  },
        }}
        ref={ref}
      >
        {isShowSearch && (
          <ListSubheader
            value=""
            disableSticky={false}
            onKeyDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => {
            e.stopPropagation();
            }}
            onClick={(e) => {
            e.stopPropagation();
            }}
            style={{
            backgroundColor: "#fff",
            zIndex: 9999,
            padding: "4px 6px",
            borderBottom: "1px solid #eee",
            height: "47px"
            }}
          >
            <TextField
              variant="outlined"
              inputRef={searchInputRef}
              autoFocus
              size="small"
              placeholder={t("SEARCH")}
              value={searchText}
              InputProps={{
                endAdornment: (
                  <React.Fragment>
                    <SearchIcon style={{ color: "#CCC" }} />
                  </React.Fragment>
                ),
              }}
              className={classes.textInput}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              onChange={(event) => {
                handleSearch(event.target.value.replace(/(\s{2,})/g, " "))
              }}
            />
          </ListSubheader>
        )}

        {loading ? (
          !isShowFooter && (
            <CircularProgress size={30} style={{ margin: "80px" }} />
          )
        ) : dropdownData !== undefined && dropdownData?.length > 0 ? (
          dropdownData.map((name) => {
            // INTERNAL comparison always uses primitive value
            const currentValue = name[valueIdentifier]

            const isChecked = isSingleSelect
              ? selectedItems === currentValue
              : selectedItems?.includes(currentValue)

            const isLimitReached =
              !isSingleSelect &&
              selectionLimit > 0 &&
              selectedItems?.length >= selectionLimit

            const isDisabled =
              name[keyPath] === disableMenuName || (isLimitReached && !isChecked)

            return (
              <MenuItem
                key={name[valueIdentifier]}
                // IMPORTANT: MUI Select value MUST be primitive
                value={currentValue}
                onClick={() => {
                  if (isSingleSelect) {
                    handleChange({ target: { value: currentValue } })
                  }
                }}
                style={{ height: subKey !== "" ? "50px" : "36px" }}
                disabled={isDisabled}
                className={classes.menuCheckbox}
              >
                {checkbox &&
                  (isSingleSelect ? (
                    <Radio
                      checked={isChecked}
                      disabled={name[keyPath] === disableMenuName}
                      style={{
                        marginRight: "10%",
                        color: "var(--primaryColor)",
                      }}
                    />
                  ) : (
                    <Checkbox
                      // {...QA_Automation?.doAddOnTestIdCommonAutoCompleteDropdownItemCheckBox(
                      //   name[keyPath]
                      // )}
                      checked={isChecked}
                      disabled={isDisabled}
                      style={{ marginRight: "0px", color: "var(--primaryColor)" }}
                    />
                  ))}

                {subKey ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span style={{ fontSize: "14px" }}>{name[keyPath]}</span>
                    <span style={{ fontSize: "12px", color: "#777" }}>
                      {name[subKey]}
                    </span>
                  </div>
                ) : (
                  <ListItemText
                    primary={name[keyPath]}
                    style={{ fontSize: "14px" }}
                  />
                )}
              </MenuItem>
            )
          })
        ) : (
          <MenuItem disabled style={{ height: "30px" }}>
            {t("NO_ITEMS_FOUND")}
          </MenuItem>
        )}

        {isShowFooter && (
          <>
            {loading ? (
              <CircularProgress size={30} style={{ margin: "80px" }} />
            ) : totalDocs > dropdownData?.length ? (
              <MenuItem
                style={{ background: "transparent" }}
                value=""
                onKeyDown={(e) => e.stopPropagation()}
              >
                <Button
                  color="primary"
                  style={{ fontWeight: 700 }}
                  onClick={() => {
                    setLoading(true)
                    handleShowMore(label)
                    setTimeout(() => {
                      setLoading(false)
                    }, 2000)
                  }}
                >
                  {t("SHOW_MORE")}
                </Button>
              </MenuItem>
            ) : null}

            <MenuItem
              disabled
              style={{
                background: "#bcb9b9",
                width: "100%",
                display: "flex",
                justifyContent: "end",
                height: "30px",
              }}
            >
              {dropdownData?.length + ` ${t("OF")} ` + totalDocs}
            </MenuItem>
          </>
        )}
      </Select>
      {error && (
        <FormHelperText
          error
          style={{ marginLeft: 14, marginRight: 14, marginTop: 4 }}
        >
          {t(helperText)}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export { SelectionLimitDropdown }
export default SelectionLimitDropdown